import { TableHeaderCell } from "../TableHeaderCell";
import { Column, SortDirection } from "../types";
import styles from './styles.module.scss'

type TabelaHeaderProps<T extends Record<string, unknown>> = {
  columns: Column<T>[];
};

export function TableHeader<T extends Record<string, unknown>>({
  columns
}: TabelaHeaderProps<T>) {
  return (
    <thead className={styles.headerContainer}>
      <tr>
        {columns.map((col) => (
          <TableHeaderCell key={String(col.key)}
            style={{ width: col.width, textAlign: col.align ?? 'center' }}
            sortable={col.sortable}
            onSort={col.onSort ? () => col.onSort!(col.key, col.sortDirection === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC) : undefined}
            currentSortDirection={col.sortable ? col.sortDirection : undefined}>
            {col.header}
          </TableHeaderCell>
        ))}
      </tr>
    </thead>
  );
}
